<template>
	<div class="row">
		<div class="col-md-5">
			<div class="card">
				<div class="card-header bg-dark">
					<h3 class="mb-0 text-white">
						ตั้งค่าเครดิตฟรีสำหรับสมาชิกใหม่
					</h3>
				</div>
				<div class="card-body">
					<form @submit.prevent="saveSetting" v-if="setting">
						<base-input
							label="จำนวน"
							placeholder="จำนวน"
							v-model.number="setting.amount"
						/>

						<div class="row">
							<div class="col-md-6">
								<base-input
									label="เทิร์น (เท่า)"
									placeholder="เทิร์น (เท่า)"
									v-model.number="setting.turn"
								/>
							</div>
							<div class="col-md-6">
								<base-input
									label="ยอดถอนสูงสุด (เท่า)"
									placeholder="ยอดถอนสูงสุด (เท่า)"
									v-model.number="setting.maxWithdraw"
								/>
							</div>
						</div>

						<base-button
							native-type="submit"
							class="mt-2"
							:disabled="loading"
						>
							บันทึกข้อมูล
						</base-button>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import api from '../services/index'
import SettingService from '../services/setting.service'

export default {
	data() {
		return {
			loading: false,
			setting: null,
		}
	},
	methods: {
		saveSetting() {
			this.loading = true
			api.post('/new-reg-bonus/setting', this.setting)
				.then(({ message }) => {
					this.$notify({ type: 'success', message })
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	created() {
		api.get('/new-reg-bonus/setting').then((res) => {
			this.setting = res
		})
	},
}
</script>
